import { render, staticRenderFns } from "./BtnElement.vue?vue&type=template&id=e2da9e5a&scoped=true&"
import script from "./BtnElement.vue?vue&type=script&lang=js&"
export * from "./BtnElement.vue?vue&type=script&lang=js&"
import style0 from "./BtnElement.vue?vue&type=style&index=0&id=e2da9e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2da9e5a",
  null
  
)

export default component.exports